// extracted by mini-css-extract-plugin
export default {"content":"detailDrawer_content__VYk+i"};